// removed by extract-text-webpack-plugin
module.exports = {"cover":"_1HFtm","hasActiveState":"LOmoW"};


//////////////////
// WEBPACK FOOTER
// ./app/components/cover/cover.scss
// module id = 1433
// module chunks = 0